export default "__VITE_ASSET__bUJukWHW__"